export default __webpack_public_path__ + "static/media/Group 3026.21d8d496.png";